const _ = require('lodash');

function CardSortService($state, localStorageService) {
    this._state = $state;
    this._localStorage = localStorageService;
    return this;
}

CardSortService.prototype.isRecencyApplicable = function (sortContext, storedSortPreference) {
    // Recency is only available for Your Specials and Lists.
    return sortContext === 'Lists' || storedSortPreference !== 'Recency';
};

CardSortService.prototype.getSortOptionIndex = function (sortTypes, sortOption) {
    return _.findIndex(sortTypes, function (sortType) {
        return sortType.Value === sortOption;
    });
};

CardSortService.prototype.getPersistedSortOptionForContext = function (sortContext, sortTypes) {
    let storedSortPreferenceIndex = -1;

    // For product groups, first visit to specific product group should automatically select Relevance.
    // If Relevance doesn't exist, it should select the persisted sort option for Product Groups.
    if (sortContext === 'ProductGroup') {
        let sessionStorageKey = `PG_${this._state.params.Id}`;
        sessionStorageKey = sessionStorageKey.replace(/\s+/g, '').toLowerCase();
        const hasBeenVisited = sessionStorage.getItem(sessionStorageKey);
        if (!hasBeenVisited) {
            try {
                sessionStorage.setItem(sessionStorageKey, 'true');

            } catch (e) {
                console.log('cannot set session storage');
            }
            storedSortPreferenceIndex = this.getSortOptionIndex(sortTypes, 'Relevance');

            if (storedSortPreferenceIndex > -1) {
                return sortTypes[storedSortPreferenceIndex];
            }
        }
    }
    const storedSortPreference = this._localStorage.getItem(sortContext);
    if (storedSortPreference) {
        storedSortPreferenceIndex = this.getSortOptionIndex(sortTypes, storedSortPreference);
    }

    //If the recency is not available for this context, then get the first sort type.
    if (!this.isRecencyApplicable(sortContext, storedSortPreference)) {
        storedSortPreferenceIndex = -1;
    }

    return storedSortPreferenceIndex > -1
        ? sortTypes[storedSortPreferenceIndex]
        : sortTypes[0];
};

module.exports = CardSortService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/card-sort-service.js
 **/